<template>
	<div>
		<div v-if="$route.name === 'detail-diagnoses'">
			<title-header
				:title="diagnostic ? diagnostic.name : 'Nombre de Diagnóstico'">
				<div class="wrapper-btns">
					<v-btn color="primary btn-action" @click="goToBack">
						<img
							src="/static/img/icons/btn-right-arrow.webp"
							alt="Atrás"
							class="mr-4"
						/>
						Atrás
					</v-btn>
				</div>
			</title-header>
			<v-layout wrap mt-5>
				<v-flex xs6 mb-5 px-2
					v-for="tool in tools"
					:key="tool.id"
				>
					<card-tool
						big
						:btn-rotated="false"
						:data="tool"
						:graphic="tool.tool.code === 'OCI'"
						view-applicants
						number-graphic
						@open-applicants="openApplicants"
						@view-summary="viewSummary"
						@view-graphic="viewGraphic"
					/>
				</v-flex>
			</v-layout>
			<modal
				:dialog="dialog"
				:create="false"
				title="Cerrar"
				@close-modal="closeModal"
				@create-employee="closeModal"
			>
			<v-layout  wrap>
				<v-flex xs8>
						<v-select
					class="select-core"
					hide-details
					label="Áreas"
					multiple
					autocomplete
					chips
					:items="groups"
					item-value="id"
					item-text="name"
					:menu-props="{ contentClass: 'type-select-content' }"
					v-model="filterArea"
					@input="filterRows($event, 'groupIds')"
				></v-select>
				</v-flex>
				</v-layout>
					<download-btn
					class="btnDow"
					alt="Descargar reporte en Excel"
					:height="23"
					url-image="/static/img/icons/excel.webp"
					@download-item="excelDowloading()"
				></download-btn>
				<button
					large
					class="mt-1 btn-clear"
					:style="`border:solid 1px ${$appColors.secondary};color:${$appColors.secondary}`"
					@click="clearFilter"
				>
				Limpiar Filtros
				</button>
				<br>
				<div class="applicants-table" :style="`border: 1px solid ${$appColors.gray}`">
					<table-modal
						:columns="columns"
						:rows="rows"
						blue
						:data="list1"
					>
						<template slot="rows" width="1" slot-scope="props">
							<td	:style="`color:${$appColors.secondary}`">
								{{ props.row.employee ? props.row.employee.name : null }} {{ props.row.employee ? props.row.employee.lastName : null }}
							</td>
							<td  :style="`color:${$appColors.secondary}`">
								{{ props.row.employee ? setGender(props.row.employee.gender) : null}}
							</td>
							<td :style="`color:${$appColors.secondary}`">
								{{ props.row.employee ? props.row.employee.documentNumber : null}}
							</td>
							<td :style="`color:${$appColors.secondary}`">
								{{  props.row.employee ? props.row.employee.email : null }}
							</td>
							<td :style="`color:${$appColors.secondary}`">
								{{ props.row.group ? props.row.group.name 	: null }}
							</td>
								<td :style="`color:${$appColors.secondary}`">
        <v-checkbox
					v-if="props.row.state == 2"
          input-value="true"
					label="Realizado"
          value
          disabled
        ></v-checkbox>
        <v-checkbox
					v-if="props.row.state == 1"
					label="No realizado"
          value
          disabled
        ></v-checkbox>
							</td>
						</template>
					</table-modal>
					<div class="pagination-container">
			<v-pagination
				v-if="totalRows > 0"
				v-model="params.page"
				:length="totalRows"
				:total-visible="7"
				@input="changePage"
				@next="loadData"
				@previus="loadData"
			></v-pagination>
		</div>
				</div>
			</modal>
		</div>
		<div v-else>
			<router-view></router-view>
		</div>
	</div>
</template>
<script>
import titleHeader from '@/components/diagnosis/title-header';
import cardTool from '@/components/diagnosis/card-tool';
import modal from '@/components/configuration/open-modal';
import tableModal from '@/components/configuration/assign-area';
import downloadBtn from '@/components/diagnosis/download-btn';

const ExportJsonExcel = require('js-export-excel');

function created() {
	if (this.$route.name === 'detail-diagnoses') {
		this.loadData();
		this.loadGroups();
	}
}
function filterRows(filter, value) {
	this.paramsGroup[value] = filter.join(',');
	this.params.page = 1;
	this.openApplicants();
}
async function loadGroups() {
	const requests = [
		this.$httpPraktiko.get('groups'),
	];
	try {
		[{ data: this.groups }]	= await Promise.all(requests);
		this.groups = this.groups.map((g) => {
			const newGroup = { ...g };
			newGroup.isSelected = false;
			return newGroup;
		});
	} catch (error) {
		this.showGenericError();
	}
}

function excelDowloading() {
	const items = this.list1.map((row) => {
		const newRow = {
			employeeName: row.employee ? row.employee.name : null,
			gender: row.employee ? row.employee.gender : null,
			documentNumber: row.employee ? row.employee.documentNumber : null,
			email: row.employee ? row.employee.email : null,
			groupName: row.group ? row.group.name : null,
			state: row.state === 2 ? 'Realizado' : 'No Realizado',
		};
		return newRow;
	});
	const option = {};
	option.fileName = 'Personal Encuesta';
	option.datas = [
		{
			sheetData: items,
			sheetName: 'hoja test',
			sheetFilter: ['employeeName', 'gender', 'documentNumber', 'email', 'groupName', 'state'],
			sheetHeader: ['Nombre del empleado', 'Genero', 'Nro de documento', 'Email', 'Area', 'Encuesta Realizada'],
			columnWidths: [10, 10, 10, 10, 10, 10],
		},
	];
	const toExcel = new ExportJsonExcel(option);
	toExcel.saveExcel();
}
async function openApplicants() {
	this.dowloadExcel();
	this.dialog = true;
	const diagnosisId = this.$route.params.id;
	try {
		if (this.paramsGroup.groupIds) {
			const { data: response } = await this.$httpPraktiko.get(`/diagnostic/${diagnosisId}/employees?page=${this.params.page}&limit=${this.params.limit}`, { params: this.paramsGroup });
			this.rows = response.results;
			this.list = response.results;
			this.totalRows = Math.ceil(response.total / this.params.limit);
			this.dialog = true;
		} else {
			const { data: response } = await this.$httpPraktiko.get(`/diagnostic/${diagnosisId}/employees?limit=${this.params.limit}&page=${this.params.page}`);
			this.rows = response.results;
			this.list = response.results;
			this.totalRows = Math.ceil(response.total / this.params.limit);
			this.dialog = true;
		}
	} catch (error) {
		this.showGenericError();
	}
}
async function dowloadExcel() {
	const diagnosisId = this.$route.params.id;
	try {
		if (this.paramsGroup.groupIds) {
			const { data: response } = await this.$httpPraktiko.get(`/diagnostic/${diagnosisId}/employees`, { params: this.paramsGroup });
			this.list1 = response;
		} else {
			const { data: response } = await this.$httpPraktiko.get(`/diagnostic/${diagnosisId}/employees`);
			this.list1 = response;
		}
	}	catch (error) {
		this.showGenericError();
	}
}
function closeModal(value) {
	this.dialog = value;
	this.filterArea = '';
	this.paramsGroup.groupIds = null;
}

function viewSummary(value) {
	const { toolId } = this.$route.params;
	if (value.tool.code === 'WEV') {
		this.goTo('detail-diagnosis-weather', { params: { toolId, idsummary: value.id } });
	} else if (value.tool.code === 'OCI') {
		this.goTo('detail-summary-inventory', { params: { toolId, idsummary: value.id } });
	} else if (value.tool.code === 'ODG') {
		this.goTo(
			'detail-summary-diagnoses',
			{ params: { toolId, id: value.diagnostic.id, detailId: value.id } },
		);
	}
}

function data() {
	return {
		tools: [],
		dialog: false,
		list: null,
		list1: null,
		filename: '',
		columns: [
			{ id: 1, name: 'NOMBRE DE EMPLEADO', col: 1 },
			{ id: 2, name: 'SEXO', col: 1 },
			{ id: 3, name: 'NRO DE DOC', col: 1 },
			{ id: 4, name: 'CORREO', col: 1 },
			{ id: 5, name: 'ÁREA', col: 1 },
			{ id: 6, name: 'Encuestas Realizadas', col: 1 },
		],
		rows: [],
		diagnostic: {},
		paramsGroup: {},
		groups: [],
		totalRows: 0,
		filterArea: '',
		params: {
			limit: 20,
			page: 1,
		},
	};
}

async function loadData() {
	try {
		const { data: response } = await this.$httpPraktiko.get(`diagnostic-detail/${this.id}`);
		this.tools = response.map((r) => {
			const newTool = { ...r };
			newTool.graphic = [
				{ image: '/static/img/diagnosis/male.svg', number: r.numMale, description: 'Masculino' },
				{ image: '/static/img/diagnosis/female.svg', number: r.numFemale, description: 'Femenino' },
			];
			newTool.value = newTool.percentageResolved || 0;
			return newTool;
		});
		this.diagnostic = this.tools[0].diagnostic || null;
	} catch (error) {
		this.showGenericError();
	}
}

function setGender(value) {
	return value === 1 ? 'Masculino' : 'Femenino';
}
function setVote(value) {
	return value === 2 ? 'Realizado' : 'No Realizado';
}
function changePage(newPage) {
	this.params.page = newPage;
	this.openApplicants();
}
function clearFilter() {
	this.paramsGroup.groupIds = null;
	this.params.page = 1;
	this.openApplicants();
	this.filterArea = '';
}
function viewGraphic(value) {
	const { toolId } = this.$route.params;
	this.goTo(
		'detail-summary-graphic-inventory',
		{
			query: {
				back: 'detail-diagnoses',
			},
			params: {
				idsummary: value.id,
				toolId,
			},
		},
	);
}

function goToBack() {
	const { toolId } = this.$route.params;
	this.goTo('diagnoses', { toolId });
}
export default {
	name: 'page-diagnoses-detail',
	data,
	created,
	components: {
		titleHeader,
		cardTool,
		modal,
		tableModal,
		downloadBtn,
	},
	methods: {
		openApplicants,
		dowloadExcel,
		filterRows,
		closeModal,
		goToBack,
		loadData,
		setGender,
		setVote,
		viewSummary,
		viewGraphic,
		excelDowloading,
		changePage,
		loadGroups,
		clearFilter,
	},
	props: {
		id: [Number, String],
	},
	watch: {
		$route(newVal) {
			if (newVal.name === 'detail-diagnoses') {
				this.loadData();
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.applicants-table {
	border-radius: 9px !important;
	box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.02) !important;
	margin-top: 30px;
	max-height: 70%;
	overflow: auto;
	font: bold 90% monospace;
}
.btnDow {
	position: absolute;
	right: 230px;
}
.search-input {
			background-color: map-get($colors, white);
			border: 1px solid map-get($colors, gray-slider);
			border-radius: 4px;
			display: inline-flex;
			height: 37px;
			max-width: 287px;
			vertical-align: middle;
			width: 100%;
}
.pagination-container {
	align-items: center;
	display: flex;
	justify-content: center;
	margin-top: 2rem;
}
.btn-clear {
	border-radius: 4px;
	height: 31px;
	width: 111px;
	position: absolute;
	right: 75px;
}
.select-core {
	float: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/diagnosis/page-diagnoses-detail.vue